import { TFunction } from 'i18next'

type VEHICLE_TYPES = 'MOTORCYCLE' | 'TRUCK' | 'CAR' | 'CARAVAN' | 'MINIBUS' | 'BUS'
const policyContextIcon: { [key in VEHICLE_TYPES]: string } = {
    MOTORCYCLE: 'wemolo-bycicle',
    TRUCK: 'wemolo-truck',
    CAR: 'wemolo-car-medium',
    CARAVAN: 'wemolo-caravan',
    MINIBUS: 'wemolo-car-van',
    BUS: 'wemolo-bus'
}

export const vehicleTypeOptions = (t: TFunction) => {
    // icon, label, id
    return Object.keys(policyContextIcon).map((key) => {
        return {
            icon: policyContextIcon[key as VEHICLE_TYPES],
            label: t(`carpay.paymentInput.vehicleTypes.${key.toLowerCase()}`),
            id: key
        }
    })
}

// car
export const defaultValueOption = (t: TFunction) => {
    return {
        icon: policyContextIcon.CAR,
        label: t('carpay.paymentInput.vehicleTypes.car'),
        id: undefined
    }
}
